var map = {
	"./Card_casino.jpg": 37791,
	"./Card_minigame.jpg": 17072,
	"./Card_slot.jpg": 8093,
	"./Card_sports.jpg": 53829,
	"./Casino_list_1.jpg": 79010,
	"./Casino_list_10.jpg": 92931,
	"./Casino_list_11.jpg": 1237,
	"./Casino_list_12.jpg": 55180,
	"./Casino_list_13.jpg": 30245,
	"./Casino_list_14.jpg": 73696,
	"./Casino_list_15.jpg": 29209,
	"./Casino_list_16.jpg": 24917,
	"./Casino_list_17.jpg": 8220,
	"./Casino_list_18.jpg": 66690,
	"./Casino_list_2.jpg": 69524,
	"./Casino_list_3.jpg": 13341,
	"./Casino_list_4.jpg": 26409,
	"./Casino_list_5.jpg": 34641,
	"./Casino_list_6.jpg": 35449,
	"./Casino_list_7.jpg": 75937,
	"./Casino_list_8.jpg": 72096,
	"./Casino_list_9.jpg": 2773,
	"./Casino_list_header.png": 36113,
	"./Main_banner_Casino.jpg": 87338,
	"./Main_banner_Minigame.jpg": 559,
	"./Main_banner_Slot.jpg": 32199,
	"./Main_casino_list_1.jpg": 4185,
	"./Main_casino_list_10.jpg": 26424,
	"./Main_casino_list_11.jpg": 52994,
	"./Main_casino_list_12.jpg": 40540,
	"./Main_casino_list_13.jpg": 45562,
	"./Main_casino_list_14.jpg": 70663,
	"./Main_casino_list_2.jpg": 62526,
	"./Main_casino_list_3.jpg": 53545,
	"./Main_casino_list_4.jpg": 42637,
	"./Main_casino_list_5.jpg": 61887,
	"./Main_casino_list_6.jpg": 46912,
	"./Main_casino_list_7.jpg": 37953,
	"./Main_casino_list_8.jpg": 107,
	"./Main_casino_list_9.jpg": 38306,
	"./Main_minigame_list_coin3.jpg": 58445,
	"./Main_minigame_list_coin5.jpg": 55956,
	"./Main_minigame_list_coinsa3.jpg": 48817,
	"./Main_minigame_list_coinsa5.jpg": 21722,
	"./Main_minigame_list_dhball.jpg": 16121,
	"./Main_minigame_list_eos3.jpg": 10373,
	"./Main_minigame_list_eos5.jpg": 46250,
	"./Main_minigame_list_pbg.jpg": 3151,
	"./Main_minigame_list_pwball.jpg": 56857,
	"./Main_slot_list_1.jpg": 47762,
	"./Main_slot_list_2.jpg": 34082,
	"./Main_slot_list_3.jpg": 42370,
	"./Main_slot_list_4.jpg": 49054,
	"./Main_slot_list_5.jpg": 75949,
	"./Main_slot_list_6.jpg": 27516,
	"./Main_sports_list_1.jpg": 21689,
	"./Main_sports_list_2.jpg": 23210,
	"./Main_sports_list_3.jpg": 7717,
	"./Main_sports_list_4.jpg": 67161,
	"./Minigame_list_coin3.jpg": 98788,
	"./Minigame_list_coin5.jpg": 57745,
	"./Minigame_list_coinsa3.jpg": 73453,
	"./Minigame_list_coinsa5.jpg": 76393,
	"./Minigame_list_dhball.jpg": 77637,
	"./Minigame_list_eos3.jpg": 22311,
	"./Minigame_list_eos5.jpg": 93674,
	"./Minigame_list_header.png": 5283,
	"./Minigame_list_pbg.jpg": 24504,
	"./Minigame_list_pwball.jpg": 55106,
	"./Mobile_Login_BG.png": 43336,
	"./Mobile_card_casino.jpg": 22169,
	"./Mobile_card_minigame.jpg": 57044,
	"./Mobile_card_slot.jpg": 55795,
	"./Mobile_card_sports.jpg": 75180,
	"./PC_Login_BG.jpg": 49381,
	"./Slot_list_header.png": 16545,
	"./Sports_list_header.png": 20596,
	"./back.png": 78591,
	"./bank-logo-nh.png": 1937,
	"./casino_active.png": 93943,
	"./contact.png": 96854,
	"./contact_active.png": 55129,
	"./deposit.png": 46496,
	"./deposit_active.png": 6745,
	"./edit_active.png": 23155,
	"./footBall_active.png": 48960,
	"./goHome.png": 84717,
	"./ham.png": 31943,
	"./history_active.png": 67000,
	"./home.png": 42112,
	"./icon-home.png": 82025,
	"./login_bg.jpg": 52396,
	"./login_bg_m.png": 55663,
	"./logo.png": 86089,
	"./logo_background.jpg": 27714,
	"./matchResult_active.png": 53376,
	"./megaphone.png": 13340,
	"./message_active.png": 58850,
	"./minigame_active.png": 33631,
	"./msg-background.svg": 27660,
	"./mypage_active.png": 9968,
	"./next.png": 34616,
	"./next_1.png": 5825,
	"./notification_active.png": 6319,
	"./partner.png": 3669,
	"./point_2.png": 97026,
	"./point_active.png": 63035,
	"./reload.png": 29477,
	"./sl_boo.png": 39108,
	"./sl_ga.png": 9580,
	"./sl_haba.png": 36810,
	"./sl_net.png": 82789,
	"./sl_pg.png": 10011,
	"./sl_pra.png": 4723,
	"./sl_ps.png": 48711,
	"./sl_red.png": 36229,
	"./slot_active.png": 13442,
	"./speaker.png": 35095,
	"./spo_bti.png": 76457,
	"./spo_dom.png": 85148,
	"./spo_fox.png": 99440,
	"./spo_pin.png": 88363,
	"./sports_list_1.jpg": 41342,
	"./sports_list_2.jpg": 38578,
	"./sports_list_3.jpg": 35634,
	"./sports_list_4.jpg": 8796,
	"./user.png": 28997,
	"./user_2.png": 28831,
	"./volume.png": 28418,
	"./wallet.png": 77363,
	"./withdraw_active.png": 69635,
	"./withdrawal.png": 88982,
	"./won_2.png": 93902
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52523;